import { render, staticRenderFns } from "./Logs.vue?vue&type=template&id=67bde3e4&scoped=true"
import script from "./Logs.vue?vue&type=script&lang=ts"
export * from "./Logs.vue?vue&type=script&lang=ts"
import style0 from "./Logs.vue?vue&type=style&index=0&id=67bde3e4&prod&lang=scss"
import style1 from "./Logs.vue?vue&type=style&index=1&id=67bde3e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bde3e4",
  null
  
)

export default component.exports